import { useQuery } from '@tanstack/react-query'

import { AdminService } from 'generated'

/**
 * Whether the signed-in user may use /admin. The server decides
 * (ADMIN_USER_IDS): GET /admin/me answers 200 for an admin and 403 for
 * everyone else. Asked once per session, never retried.
 */
const useIsAdmin = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['admin-me'],
    queryFn: () => AdminService.getAdminMe(),
    retry: false,
    staleTime: Infinity,
  })

  return { isAdmin: !!data?.data?.admin, isLoading }
}

export default useIsAdmin
